import { gql } from "@apollo/client";
import React from "react";
import styled from "styled-components";
import { TextInput } from "components/inputs/Inputs";
import { GraphqlMutation } from "graphqlUtils/GraphqlMutation";
import { useTheme } from "@mui/material/styles";

import {
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Typography,
} from "@mui/material";

const ADD_CONTACT = gql`
  mutation CreateNurseryContact($input: CreateNurseryContactInput!) {
    createNurseryContact(input: $input) {
      id
      name
      email
      shouldReceiveReminders
      agreedToReceiveReminders
    }
  }
`;
const Div = styled.div`
  margin: 0 auto 20px auto;
`;

export const AddNurseryContactModal = (props) => {
  const { onCancel, refetchQueries, open, onSubmit, nurseryId } = props;
  const [name, updateName] = React.useState("");
  const [email, updateEmail] = React.useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Just a very simple email validator.
  const emailError = Boolean(email) && !/^\S+@\S+\.\S+$/.test(email);
  const emailHelper = emailError ? "Invalid email" : "";
  return (
    <Dialog disableEscapeKeyDown fullScreen={fullScreen} maxWidth="md" fullWidth open={open}>
      <DialogTitle>
        <Typography variant="h4" component="h4">
          Add Nursery Contact
        </Typography>
      </DialogTitle>
      <Div>
        <DialogContent>
          <TextInput
            required
            label="Enter a name..."
            variant="outlined"
            value={name}
            onChange={(event) => updateName(event.target.value)}
          />
        </DialogContent>
        <DialogContent>
          <TextInput
            required
            label="Enter a valid email..."
            variant="outlined"
            value={email}
            helperText={emailHelper}
            error={emailError}
            onChange={(event) => updateEmail(event.target.value)}
          />
        </DialogContent>
      </Div>
      <DialogContent>
        <Typography variant="body1" component="p">
          Once created an email will be sent {name ? `to ${name}` : ""} with instructions on how
          to sign up, so make sure the email is correct.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            updateName("");
            updateEmail("");
            onCancel();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <GraphqlMutation mutation={ADD_CONTACT} withError>
          {(addContact) => {
            const submit = async () => {
              if (emailError) return;

              const variables = { input: { nurseryId, name, email } };
              const result = await addContact({ variables, refetchQueries });
              if (result.data) {
                updateName("");
                updateEmail("");
                onSubmit();
              }
              return result;
            };

            return (
              <Button disabled={emailError || !email || !name} onClick={submit} color="primary">
                Create
              </Button>
            );
          }}
        </GraphqlMutation>
      </DialogActions>
    </Dialog>
  );
};
